import Typography from 'components/shared/Typography/Typography';

import { PRE_AUTH_PHASE_COPY, getPreAuthStatementParts, getScopeLabel } from '../lib/helpers';

const { statement: STATEMENT_COPY } = PRE_AUTH_PHASE_COPY;

const ScopeTail = ({ label }) => {
  if (!label) return null;
  return (
    <>
      {' for '}
      <span className="font-semibold">{label}</span>
    </>
  );
};

const PreAuthStatement = ({ phase, selectedScope, amounts, oonResponsibility = null }) => {
  if (!phase) return null;
  const { isSelfPay, capLabel, graceDays, scopeLabel } = getPreAuthStatementParts(
    phase,
    undefined,
    amounts,
    oonResponsibility
  );
  const effectiveScope = selectedScope ? getScopeLabel(selectedScope) : scopeLabel;

  return (
    <Typography variant="p" size="small" className="block">
      {isSelfPay ? (
        <>
          {STATEMENT_COPY.selfPayPrefix}
          <span className="font-semibold">{capLabel}</span>
          <ScopeTail label={effectiveScope} />.
        </>
      ) : (
        <>
          {STATEMENT_COPY.insuredPrefix}
          <span className="font-semibold">{graceDays}</span>
          {STATEMENT_COPY.insuredDaysSuffix}
          <span className="font-semibold">{capLabel}</span>
          <ScopeTail label={effectiveScope} />.
        </>
      )}
    </Typography>
  );
};

export default PreAuthStatement;
